var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classComponent},[_c('div',{staticStyle:{"height":"180px"}},[_c('img',{staticStyle:{"width":"100%","height":"100%","-o-object-fit":"cover","object-fit":"cover","-o-object-position":"center","object-position":"center"},attrs:{"src":_vm.imageSource}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }